<div class="flex flex-col">
	<div class="border-b border-grey-light pb-4">
		<h4>{{ ordinalNumber }} mortgage</h4>
		<p class="mt-4">Please select the lender forms you would like to import</p>
	</div>
	<div>
		<app-charge-type-select
			[mortgage]="mortgage"
			[showLabels]="true"
		></app-charge-type-select>
		<app-container class="mt-4" *ngIf="formsList && formsList?.length > 0">
			<div
				*ngFor="let form of formsList"
				(click)="toggleMortgageForms(form.form)"
				[ngClass]="{
					selected: isFormSelected(form.form),
					unselected: !isFormSelected(form.form),
				}"
			>
				<app-icon
					[icon]="ICON.CHECK"
					class="text-green-light mr-4"
					*ngIf="isFormSelected(form.form)"
				></app-icon>
				{{ form.name }}
			</div>
		</app-container>
	</div>
</div>
